export enum CookieKey {
  UserTenant = 'selected-tenant',
  PortalLanguage = 'selected-portal-language',
  TecDocLanguage = 'selected-tecdoc-language',
  AuthTokenStorage = 'id_token_claims_obj',
}